<template>
  <v-app>
    <router-view/>
  </v-app>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  name: 'App',
  components: {
  },
  created () {
    window.addEventListener('storage', this.storageEvent, false)
  },
  methods: {
    storageEvent (e) {
      this.$log.info('storage event')
      this.$log.debug(e)
    }
  }
})
</script>

<style>
html {
  overflow-x: hidden;
}
@import './assets/styles/common.css'
</style>
